import EmployeeTemplate, { AccessType, LoginType } from '../models/employee-template';

export const EMPLOYEE_TEMPLATES: Array<EmployeeTemplate> = [EmployeeTemplate.getInstanceFromObject({
    id: 'f8ac59e9-254f-4751-9d1c-dc2372fadd1b',
    name: 'Default',
    accessLevel: AccessType.SITE_LEVEL,
    hasLogin: true,
    LoginType: LoginType.PHONE,
})];
